export function toTitleCase(str: string) {
  return str
    .replace(/_/g, " ")
    .toLowerCase()
    .split(" ")
    .map(word => word[0].toUpperCase() + word.slice(1))
    .join(" ");
}
